<div
  id="{{ createAttributeIdForConfigurator(attribute) }}"
  class="form-group"
  *ngIf="attribute?.values?.length"
>
  <select
    class="form-control"
    [formControl]="attributeDropDownForm"
    [cxFocus]="{ key: attribute.name }"
    (change)="onSelect(attributeDropDownForm.value)"
  >
    <option
      *ngFor="let item of attribute.values"
      [label]="item.valueDisplay"
      [selected]="item.selected"
      [value]="item.valueCode"
    >
      {{ item.valueDisplay }}
    </option>
  </select>
</div>

<cx-configurator-attribute-product-card
  *ngIf="selectionValue?.valueCode !== '0'"
  id="{{
    createAttributeValueIdForConfigurator(attribute, selectionValue.valueCode)
  }}"
  (handleDeselect)="onSelect('0')"
  [productCardOptions]="extractProductCardParameters()"
>
</cx-configurator-attribute-product-card>

<div *ngIf="withQuantity" class="cx-attribute-level-quantity-price">
  <cx-configurator-attribute-quantity
    (changeQuantity)="onChangeQuantity($event, attributeDropDownForm)"
    [quantityOptions]="extractQuantityParameters(attributeDropDownForm)"
  ></cx-configurator-attribute-quantity>
  <cx-configurator-price
    [formula]="extractPriceFormulaParameters()"
  ></cx-configurator-price>
</div>
